import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientTimePipe } from '../pipes/client-time.pipe';

@NgModule({
  declarations: [ClientTimePipe],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, ClientTimePipe],
})
export class SharedPrimitivesModule {}
